export default {
  drugInfo: () => import('./drugInfo/index.vue'), // 药品信息管理
  drugDetail: () => import('./drugDetail/index.vue'), // 项目配置
  quickEdit: () => import('./quickEdit/index.vue'), // 项目配置
  purchase: () => import('./purchase/index.vue'), // 采购管理
  purchaseDetail: () => import('./purchaseDetail/index.vue'), // 采购管理
  purchaseRetreat: () => import('./purchaseRetreat/index.vue'), // 采购退货
  purchaseRetreatDetail: () => import('./purchaseRetreatDetail/index.vue'), // 退货详情
  stock: () => import('./stock/index.vue'), // 库存管理
  inventory: () => import('./inventory/index.vue'), // 盘点管理
  inventoryQuery: () => import('./inventoryQuery/index.vue'), // 确认盘点
  newInventory: () => import('./newInventory/index.vue'), // 新增盘点
  inventoryDetail: () => import('./inventoryDetail/index.vue'), // 盘点详情
  stockWarn: () => import('./stockWarn/index.vue'), // 库存预警
  validityWarn: () => import('./validityWarn/index.vue'), // 效期提醒
  flowQuery: () => import('./flowQuery/index.vue'), // 流向查询
  template: () => import('./template/index.vue'), // 模板页面
};
